import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ApolloLink } from '@apollo/client';
/**
 * Add a new apollo-link `customHeadersLink`.
 * This link will apply custom headers to each graphql operation.
 * These custom headers are extracted from the global window variable `crehApolloHeaders`.
 * You can set this `window.crehApolloHeaders` global variable before running a graphql in order to apply custom headers.
 */
export var customHeadersLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  if (typeof window !== 'undefined' && window.crehApolloHeaders) {
    operation.setContext(function (_ref) {
      var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      return {
        headers: _objectSpread(_objectSpread({}, headers), window.crehApolloHeaders || {})
      };
    });
  }
  return forward(operation);
});